import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {NumeralService} from "../../services/Numeral.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {Session} from "../../services/Session";
import * as Highcharts from 'highcharts';
import {HighchartsChartModule} from "highcharts-angular";

declare const _: any;

@Component({
  selector: 'app-cashflow-timeline',
  standalone: true,
  imports: [CommonModule, FormsModule, HighchartsChartModule],
  templateUrl: './cashflow-timeline.component.html',
  styleUrl: './cashflow-timeline.component.scss'
})
export class CashflowTimelineComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @Input() clientId: any;
  @Input() planYear: any;
  @Input() clientData: any;
  @Input() clientTaxplanData: any;
  chartColors: Array<any> = ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'];
  graphData: any;
  hasGraphData = false;
  groupedTimelineChartOptions: any;
  columns: Array<any> = [];
  Highcharts: typeof Highcharts = Highcharts;

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService
  ) {}

  ngOnInit(): void {
    const base = this;
    this.user = Session.getUser();
    this.getTimelineGraphData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.switchBoard.onToggleFeedback.next({
      display: false
    });
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }

  getTimelineGraphData() {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getCashflowTimelineGraphData(this.org, this.user.id, this.clientTaxplanData.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const timelineData = response.data;
        this.columns = timelineData.columns;
        this.graphData = _.cloneDeep(timelineData) || {};
        delete this.graphData.columns;
        this.hasGraphData = true;
        this.groupedTimelineChartOptions = {
          colors: this.chartColors,
          chart: {
            type: 'column',
            style: {
              fontFamily: 'Arial',
            }
          },
          title: {
            text: 'Timeline',
            align: 'left',
            style: {
              color: '#444',
              fontFamily: 'Raleway-Regular',
              fontSize: '24'
            }
          },
          credits: {
            enabled: false
          },
          xAxis: {
            categories: this.columns,
            type: 'category',
            labels: {
              style: {
                fontSize: '13px',
              }
            }
          },
          yAxis: {
            title: {
              text: '',
              style: {
                fontSize: '15px'
              }
            },
            labels: {
              style: {
                fontSize: '13px',
              },
              formatter: function() {
                if (this.value >= 1E6) {
                  return '$' + (this.value / 1000000).toFixed(2) + 'M';
                }
                return '$' + this.value / 1000 + 'k';
              }
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                formatter() {
                  return base.formatAmount(this.y);
                }
              }
            }
          },
          tooltip: {
            formatter() {
              return '<b>' + this.x + '</b><br/>' +
                base.formatAmount(this.y) + '<br/>';
            }
          },
          series: [{
            colorByPoint: true,
            data: base.getFormatedGraphData()
          }],
        };
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get graph data');
      });
  }

  getFormatedGraphData() {
    const base = this;
    const array = [];
    _.each(this.columns, (col) => {
      array.push({
        name: col,
        y: base.graphData[col] ? base.graphData[col] : 0
      });
    });
    return array;
  }

}
